import GeoTrace from '../../network/assets/js/geo-script.js';

/**
 * Class ProductsCatalog
 */
export default class ProductsCatalog {

	constructor() {
		this.data = window.productsCatalogData;
		this.currency = { currency: 'USD' };
		this.addToCartSelector = 'a[href^="#elementor-add-to-cart-url|"]';
		this.upgradeSelector = 'a[href^="#elementor-subscription-url|upgrade|"]';
		this.run();
	}

	async run() {

		this.currency = await this.getUserCurrency();
		window.userCurrency = this.currency;

		// Pricing
		document.querySelectorAll( '[data-product][data-plan][data-attribute],[data-elementor-products-catalog]' ).forEach( element => {
			
			let attributes = {};
			attributes.product = element.getAttribute( 'data-product' );
			attributes.plan = element.getAttribute( 'data-plan' );
			attributes.attribute = element.getAttribute( 'data-attribute' );
			attributes.tier = element.getAttribute( 'data-tier' );
			
			const elementorProductsCatalogData = element.dataset.elementorProductsCatalog;
			if( !attributes.product && elementorProductsCatalogData ) {
				try {
					attributes = JSON.parse( elementorProductsCatalogData );
				} catch (e) {
					console.warn('Invalid JSON in elementorProductsCatalog:', e);
					return;
				}
			}
			

			const product = attributes.product;
			const plan = attributes.plan;
			const attribute = attributes.attribute;
			const tier = attributes.tier;

			if( !product || !plan || !attribute ) {
				return;
			}

			let planData = this.getPlanData( product, plan );
			if( !planData ) { 
				return;
			}

			if( tier ){
				const tiers = planData.tiers;
				if( tiers ){
					const tierData = tiers.find( t => t.upTo === Number(tier) );
					if( tierData ){
						planData = tierData;
					}
				}
			}

			const priceList = planData[ attribute ];
			if( !priceList ) {
				return;
			}

			let value = "";
			if( typeof priceList === "object" ) {
				value = priceList[ window.userCurrency.currency ] ? priceList[ window.userCurrency.currency ] : "";
			} else {
				value = priceList;
			}

			element.innerText = value;
			element.removeAttribute( 'data-elementor-products-catalog' );
		});

		// Add to cart links
		document.querySelectorAll( this.addToCartSelector ).forEach( element => {
			if ( this.setAddToCartUrlForElement( element ) ) {
				element.onclick = () => this.pushTrackingData( element );
			}
		});

		// Upgrade links
		document.querySelectorAll( this.upgradeSelector ).forEach( element => {
			if ( this.setUpgradeAttributes( element ) ) {
				element.onclick = () => this.pushTrackingData( element );
			}
		});

		document.querySelectorAll( "[data-products-catalog='currency']" ).forEach( element => {
			const formatted = new Intl.NumberFormat('en-US', {
				style: 'currency',
				currency: this.currency.currency
			}).formatToParts(1000);
			const symbol = formatted.find(part => part.type === 'currency').value;
			element.innerHTML = symbol;
			element.removeAttribute( 'data-products-catalog' );
		});
	}

	setAddToCartUrlForElement( element ) {
		const href = element.href;
		if( ! href ) {
			return;
		}

		const parts = href.split( '|' );
		const product = parts[1];
		const plan = parts[2];

		if( !product || !plan ) {
			return;
		}
	
		const planData = this.getPlanData( product, plan );
		if( !planData ) {
			return;
		}

		const addToCartData = planData.addToCartUrl;
		if( !addToCartData ) {
			return;
		}

		element.href = addToCartData;
		return true;
	}

	setUpgradeAttributes( element ) {
		const href = element.href;
		if ( ! href ) {
			return;
		}

		const parts = href.split( '|' );
		const plan = parts[2];
		const allowedActivations = parts[3];
		const tracking = parts[4];

		element.setAttribute( 'href', '#' );
		element.setAttribute( 'data-upgrade', plan );
		element.setAttribute( 'data-allowedactivations', allowedActivations );
		const tracking_data = JSON.parse( decodeURIComponent( tracking.replace(/\+/g, ' ') ) );
		element.setAttribute( 'tracking-data', JSON.stringify( tracking_data ) );
		return true;
	}

	pushTrackingData( element ) {
		if ( ! window.dataLayer || ! dataLayer.push ) {
			return;
		}

		let params = {};
		if ( element.hasAttribute( 'tracking-data' ) ) {
			const trackingData = element.getAttribute( 'tracking-data' );
			if ( trackingData ) {
				params = this.getParamsObject( JSON.parse( trackingData ) );
			}
			const previousPlanSku = element.getAttribute( 'data-upgrade-from' );
			if ( previousPlanSku ) {
				params.previous_plan_sku = previousPlanSku;
			}

		}else{
			const data = this.urlParam( element.href, 'edata');
			if ( ! data ) {
				return;
			}
			const product = JSON.parse( decodeURIComponent( data.replace( /\+/g, ' ' ) ) );
			params = this.getParamsObject( product );
		}
		window.dispatchEvent( new CustomEvent( 'elementor-network/products_catalog/params', { detail: { params, element } } ) );
		dataLayer.push( params );
	}

	getPlanData( product, plan ) {
		const productData = this.data.products[ product ];
		if( !productData ) {
			return;
		}
		const planData = productData.plans[ plan ];
		if( !planData ) {
			return;
		}
		return planData;
	}

	async getLocationCode() {
		return await new GeoTrace().getLocationCode();
	}

	async getUserCurrency() {
		const locationCode = await this.getLocationCode();
		const currenciesCountries = window.productsCatalogData.currencies;
		return currenciesCountries[ locationCode ] ? currenciesCountries[ locationCode ] : currenciesCountries.default;
	}

	getParamsObject( product ) {
		const currency = this.currency.currency;
		const price = this.isString( product.price ) ? product.price : product.price[currency];
		const params =  {
			event: 'add_to_cart',
			plan_sku: product.name,
			ecommerce: {
				currency: currency,
				value: price,
				items: [
					{
						item_id: product.id,
						item_name: product.name,
						item_category: product.category,
						price: price,
						quantity: 1
					}
				]
			}
		}
		if ( product.tier ) {
			params.level_1 = product.tier;
		}
		return params;
	}

	isString( inputText ) {
		return typeof inputText === 'string' || inputText instanceof String;
	}

	urlParam( url, param ) {
		const results = new RegExp('[\?&]' + param + '=([^&#]*)').exec(url);
		if (results && results[1]) {
			return results[1];
		}
		return 0;
	}
}

if ( window.productsCatalogData ) {
	window.productsCatalog = new ProductsCatalog();
}
